var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgScrollUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 15 23",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.939.229L.208 6.959c-.203.204-.264.197-.154.463.11.265.369.126.657.126H5.45v13.476c0 1.046.954 1.895 2 1.895 1.047 0 2-.85 2-1.895V7.548h4.722c.287 0 .546.139.656-.126.037-.088.055-.024.055-.116 0-.185-.073-.29-.21-.424L7.944.19c-.277-.278-.727-.24-1.004.039",
    fill: "#FFF",
    fillRule: "evenodd"
  })));
}

export default SvgScrollUp;